<template>
  <PowerUpFocusedPageLayout
    :title="t(pageTitle)"
    :back-aria-label="t(strings.back_to_account_aria)"
    :back-to="accountLinks.home.path"
  >
    <ContentWidth variant="narrow" class="py-4 py-sm-6">
      <SettingsSectionAsync :section="section" />
    </ContentWidth>
  </PowerUpFocusedPageLayout>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ContentWidth } from "@saflib/vue/components";
import { SettingsSectionAsync } from "@saflib/ory-kratos-spa/settings";
import type { SettingsTabQueryValue } from "@saflib/ory-kratos-spa/settings";
import { PowerUpFocusedPageLayout } from "@vendata/power-up-sdk/components";
import { accountLinks } from "@vendata/power-up-links";
import { useReverseT } from "../../i18n.ts";
import { account_settings_section as strings } from "./AccountSettingsSection.strings.ts";

const props = defineProps<{
  section: Extract<
    SettingsTabQueryValue,
    "profile" | "email" | "password" | "totp"
  >;
}>();

const { t } = useReverseT();

const pageTitle = computed(() => {
  switch (props.section) {
    case "profile":
      return strings.profile_title;
    case "email":
      return strings.email_title;
    case "password":
      return strings.password_title;
    case "totp":
      return strings.mfa_title;
  }
});
</script>
